import { Identifiable, Project, ProjectResource, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeResourceFromProjectAndTransferAllocations(
  httpClient: HttpClient,
) {
  return (
    project: Identifiable<Project>,
    from: Identifiable<ProjectResource>,
    to: Identifiable<ProjectResource>,
    tasks: Identifiable<Task>[],
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/projects/${project.uuid}/delete-resource-project-and-transfer-allocation`,
        method: HttpMethods.DELETE,
        data: {
          source: from.uuid,
          destination: to.uuid,
          tasks: tasks.map((t) => t.uuid),
        },
      })
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { removeResourceFromProjectAndTransferAllocations };
